import Swiper, { Navigation, Pagination } from 'swiper';
import $ from 'jquery';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

let windowWidth = $(window).width();

function initBlockWithTabsAndSlider() {
  const sliders = $('.itinerary-carousel');
  // const breakpoints = [];
  const keyCodesAvailable = [undefined, 1, 13, 32];

  document.querySelectorAll('.itinerary-carousel').forEach((slider) => {
    const sliderItem = new Swiper(slider.querySelector('.itinerary-carousel__swiper-container'), {
      init: false,
      modules: [Navigation, Pagination, HideOffscreenSlides],
      speed: 700,
      slidesPerView: 1,
      spaceBetween: 15,
      autoHeight: true,
      navigation: {
        nextEl: slider.querySelector('.itinerary-carousel__nav--next'),
        prevEl: slider.querySelector('.itinerary-carousel__nav--prev'),
      },
      pagination: {
        el: slider.querySelector('.itinerary-carousel__swiper-pagination'),
      },
      on: {
        init: () => {
          $(sliderItem.$el).find($('a')).attr('tabindex', -1);
          $(sliderItem.$el).find($('.swiper-slide-active')).find($('a')).attr('tabindex', 0);
        },
        slideChangeTransitionEnd: () => {
          $(sliderItem.$el).find($('a')).attr('tabindex', -1);
          $(sliderItem.$el).find($('.swiper-slide-active')).find($('a')).attr('tabindex', 0);
        },
      },
    });

    sliderItem.init();
    sliders.push(sliderItem);

    const sliderTabsInside = slider.querySelectorAll('.itinerary-carousel__name');
    let sliderTabsWrapper = slider.querySelector('.itinerary-carousel__tabs');
    const blockId = slider.id;

    for (let i = 0; i < sliderTabsInside.length; i++) {
      const newTab = document.createElement('li');
      newTab.classList.add('itinerary-carousel__tab');
      newTab.setAttribute('data-index', i);
      newTab.setAttribute('id', `${blockId}-tab-${i}`);
      newTab.setAttribute('role', 'tab');
      newTab.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      newTab.setAttribute('aria-controls', `${blockId}-panel-${i}`);
      newTab.setAttribute('tabindex', i === 0 ? 0 : -1);
      newTab.textContent = sliderTabsInside[i].textContent;
      sliderTabsWrapper.append(newTab);

      if (newTab.textContent <= 0) {
        newTab.classList.add('itinerary-carousel__tab--empty');
      }

      sliderTabsInside[i].remove();
    }

    if (sliderTabsWrapper.tagName.toLowerCase() === 'div') {
      const ulWrapper = document.createElement('ul');

      Array.from(sliderTabsWrapper.attributes).forEach((attr) => {
        ulWrapper.setAttribute(attr.name, attr.value);
      });

      while (sliderTabsWrapper.firstChild) {
        ulWrapper.appendChild(sliderTabsWrapper.firstChild);
      }

      sliderTabsWrapper.replaceWith(ulWrapper);
      sliderTabsWrapper = ulWrapper;
    }

    const sliderTabs = slider.querySelectorAll('.itinerary-carousel__tab');

    function syncActiveTab(activeIndex) {
      sliderTabs.forEach((elem) => {
        const isActive = Number(elem.dataset.index) === Number(activeIndex);
        elem.classList.toggle('active', isActive);
        elem.setAttribute('aria-selected', String(isActive));
        elem.setAttribute('tabindex', isActive ? 0 : -1);
      });
    }

    for (let i = 0; i < sliderTabs.length; i++) {
      sliderTabs[0].classList.add('active');

      $(sliderTabs[i]).on('click keyup', (event) => {
        if (keyCodesAvailable.indexOf(event.keyCode) !== -1) {
          syncActiveTab(i);
          sliderItem.slideTo(sliderTabs[i].dataset.index);
        }
      });

      sliderTabs[i].addEventListener('keydown', (event) => {
        const totalTabs = sliderTabs.length;
        const currentIndex = Number(sliderTabs[i].dataset.index);
        let newIndex;

        switch (event.key) {
          case 'ArrowRight':
            newIndex = (currentIndex + 1) % totalTabs;
            break;
          case 'ArrowLeft':
            newIndex = (currentIndex - 1 + totalTabs) % totalTabs;
            break;
          case 'Home':
            newIndex = 0;
            break;
          case 'End':
            newIndex = totalTabs - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        syncActiveTab(newIndex);
        sliderItem.slideTo(sliderTabs[newIndex].dataset.index);
        sliderTabs[newIndex].focus();
      });
    }

    sliderItem.on('slideChange', () => {
      const currentIndex = sliderItem.realIndex;
      syncActiveTab(currentIndex);
    });

    const prevSlideBtn = slider.querySelector('.itinerary-carousel__nav--prev');
    const nextSlideBtn = slider.querySelector('.itinerary-carousel__nav--next');
    const mobileControlsWrapper = slider.querySelector('.itinerary-carousel__mobile-btns');

    prevSlideBtn.setAttribute('tabindex', 0);
    nextSlideBtn.setAttribute('tabindex', 0);

    if (window.innerWidth < 992) {
      mobileControlsWrapper.append(prevSlideBtn);
      mobileControlsWrapper.append(nextSlideBtn);

      const clones = slider.querySelectorAll('.itinerary-carousel__item');

      slider.querySelectorAll('.swiper-slide').forEach((elem) => elem.remove());

      for (let i = 0; i < clones.length; i++) {
        const newSlide = document.createElement('p');
        newSlide.classList.add('swiper-slide');
        newSlide.append(clones[i]);
        slider.querySelector('.swiper-wrapper').append(newSlide);
      }
    }
  });
}

$(window).on('load', () => {
  initBlockWithTabsAndSlider();
});

$(window).on('resize', () => {
  if ($(window).width() !== windowWidth) {
    windowWidth = $(window).width();
    initBlockWithTabsAndSlider();
  }
});
